<template>
  <footer class="apn-footer">
      <div class="apn-container">
        <section class="section section--left">
            &copy; Copyright {{ year }} MyanmarAPN. All rights reserved.
        </section>
        <section class="section section--right">
            Make with love by 
            <a href="https://venuslab.co/" target="_blank">Venus Lab</a>
        </section>
      </div>
  </footer>
</template>

<script>
export default {
  name: 'ApnFooter',
  data() {
    return {
        year: new Date().getFullYear(),
    }
  }
}
</script>

<style scoped lang="scss">
.apn-footer {
    width: 100%;
    background-color: var(--footer-bg);
    .apn-container {
        padding: 20px 20px;
        @media (min-width: 992px) {
            display: flex;
            justify-content: space-between;
            padding: 30px 20px;
        }
        .section {
            text-align: center;
            font-size: .8rem;
            color: #fff;
            font-weight: 300;
            a {
                color: inherit;
            }
        }
    }
}
</style>
